import React from 'react';
import PropTypes from 'prop-types';

/**
 * AMPProvider. Used to wrap an application to provide an isAMP context.
 */
class AMPProvider extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        isAMP: PropTypes.bool
    };

    static defaultProps = {
        isAMP: false
    };

    getChildContext() {
        return {
            isAMP: this.props.isAMP
        };
    }

    render() {
        return this.props.children;
    }
}

AMPProvider.childContextTypes = {
    isAMP: PropTypes.bool
};

/**
 * A HOC to provide an isAMP prop to a child component.
 *
 * @param {React.Component|function} Component A react component to wrap
 *
 * @returns {React.Component|*} Returns the passed in component with an isAMP prop
 */
export const withAMP = Component => {
    // eslint-disable-next-line react/prefer-stateless-function
    class Container extends React.Component {
        static displayName = `withAMP(${Component.displayName || Component.name})`;

        static propTypes = {
            render: PropTypes.func,
            children: PropTypes.any
        };

        render() {
            return <Component isAMP={this.context.isAMP} {...this.props} />;
        }
    }

    Container.contextTypes = {
        isAMP: PropTypes.bool
    };

    return Container;
};

/**
 * A component that only renders it's children when isAMP is true.
 * Can also be used as a render-props component.
 */
export class WithAMP extends React.Component {
    propTypes = {
        render: PropTypes.func,
        children: PropTypes.any
    };

    render() {
        const isAMP = this.context.isAMP;
        const render = this.props.render;
        const children = this.props.children;

        // if a render prop was given, call it and pass isAMP
        if (render) {
            return render(isAMP);
        }

        // if isAMP, render children
        if (isAMP) {
            return children;
        }

        // default, do not render children
        return null;
    }
}

WithAMP.contextTypes = {
    isAMP: PropTypes.bool
};

export default AMPProvider;
